import { render, staticRenderFns } from "./reverse-relevance.vue?vue&type=template&id=02b74544&scoped=true&"
import script from "./reverse-relevance.ts?vue&type=script&lang=ts&"
export * from "./reverse-relevance.ts?vue&type=script&lang=ts&"
import style0 from "./reverse-relevance.vue?vue&type=style&index=0&id=02b74544&prod&lang=less&scoped=true&"
import style1 from "./reverse-relevance.vue?vue&type=style&index=1&id=02b74544&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b74544",
  null
  
)

export default component.exports